import { Dialog, Fade, useTheme } from "@mui/material";
import type { FC, PropsWithChildren } from "react";
import { CONTACT_DIALOG_AUTO_CLOSE_MS } from "web_myplann/Shared/constants";
import { useAutoClose } from "web_myplann/Shared/Hooks/useAutoClose";

type Props = {
	open: boolean;
	onClose?: () => void;
	autoFadeOut?: boolean;
	closeOnBackdropClick?: boolean;
};

export const FinanceDialog: FC<PropsWithChildren<Props>> = ({
	open,
	onClose,
	children,
	autoFadeOut,
	closeOnBackdropClick,
}) => {
	const theme = useTheme();
	useAutoClose(open && !!autoFadeOut, CONTACT_DIALOG_AUTO_CLOSE_MS, onClose);

	return (
		<Dialog
			slots={{ transition: Fade }}
			slotProps={{
				paper: { sx: { borderRadius: theme.radii.lg } },
				transition: {
					timeout: autoFadeOut ? { enter: 1000, exit: 1000 } : 0,
				},
			}}
			disableEscapeKeyDown
			onClose={(_, reason) => {
				if (!open) return;
				if (reason === "backdropClick" && !closeOnBackdropClick) return;
				onClose?.();
			}}
			open={open}
		>
			{children}
		</Dialog>
	);
};
